import { ActionBase } from '../../../core/store/action/ActionBase';

export const DELETE_CODESYSTEMVERSION_DRAFT = '[Vocabulary] Delete CodeSystemVersion Draft';

export class DeleteCodeSystemVersionDraftAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = DELETE_CODESYSTEMVERSION_DRAFT;

  constructor(public payload: { key: string }) {}
}



// WEBPACK FOOTER //
// ./src/app/vocabulary/store/actions/DeleteCodeSystemVersionDraftAction.ts